import { defineStore } from "pinia";
import { ref, onMounted, onUnmounted } from "vue";

export const useRedirectStore = defineStore("redirect", () => {
  const isRedirecting = ref<boolean>(false);

  // 1. Centralized redirect function
  const toExternal = (options: { url?: string; openInNewTab: boolean }): void => {
    if (!options.url) {
      throw new Error("Redirect url not provided.");
    }
    if (options?.openInNewTab) {
      window.open(`${options.url}`, "_blank");
    } else {
      window.location.replace(`${options.url}`);
    }

    isRedirecting.value = true;
  };

  // 2. Clear state if user comes back via browser history
  const handlePageShow = (event: PageTransitionEvent): void => {
    if (event.persisted) {
      isRedirecting.value = false;
    }
  };

  // 3. Lifecycle-managed event listeners to prevent memory leaks
  onMounted(() => {
    window.addEventListener("pageshow", handlePageShow);
  });

  onUnmounted(() => {
    window.removeEventListener("pageshow", handlePageShow);
  });

  return {
    isRedirecting,
    toExternal,
  };
});
